import React, { useMemo } from 'react';
import { Form, FormInstance } from 'antd';

export const EditableTableContext = React.createContext<{
  form?: FormInstance<any>;
}>({});

const EditableRow = ({ ...props }) => {
  const [form] = Form.useForm();

  const contextValue = useMemo(() => ({ form }), [form]);

  return (
    <EditableTableContext.Provider value={contextValue}>
      <Form form={form} component={false}>
        <tr {...props} />
      </Form>
    </EditableTableContext.Provider>
  );
};

export default EditableRow;
